import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useActiveSlide } from '../../ActiveSlideProvider';

export default function MobileMap({ events, zoom, height, centerEvent }) {
    const {activeSlide} = useActiveSlide();
    const mapContainerRef = useRef();
    const mapRef = useRef();

    useEffect(() => {
      if (events && centerEvent) {
        setLng(centerEvent.venues[0] ? centerEvent.venues[0].gps_longitude : -122.3328);
        setLat(centerEvent.venues[0] ? centerEvent.venues[0].gps_latitude : 47.6061);
      } else {
        setLng(-122.3328);
        setLat(47.6061);

      }
    }, [activeSlide, events, centerEvent]);

    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    const [lng, setLng] = useState(-122.3328);
    const [lat, setLat] = useState(47.6061); 
    const [zoomLevel] = useState(zoom);

  useEffect(() => {
    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      center: [lng, lat], 
      zoom: zoomLevel, 
      style: 'mapbox://styles/mapbox/light-v11', //streets-v11
    },[]);

    mapRef.current.addControl(new mapboxgl.NavigationControl());

    events.forEach((event) => {
      if (event.venues[0].gps_longitude && event.venues[0].gps_latitude) {
        let color;
        if (event && centerEvent) {
          color = event.venues[0].gps_longitude === centerEvent.venues[0].gps_longitude ? "#9D2045" : "#000000";
        } else {
          color = "#9D2045";
        }
        new mapboxgl.Marker({color: color})
        .setLngLat([event.venues[0].gps_longitude, event.venues[0].gps_latitude])
        .setPopup(
          new mapboxgl.Popup({ maxWidth:'none', closeOnMove:true })
            .setHTML(
              `<a href=${`/event/${event.id}`} style="color: #000000;"><h6>${event.venues[0].name}</h6></a>
                <p>${event.venues[0].address_street} ${event.venues[0].address_city} ${event.venues[0].address_state}</p>`
            )
        )
        .addTo(mapRef.current)
      }
    });
  });

  return (
    <div
      style={{ height: height, borderRadius: 5 }}
      ref={mapContainerRef}
      className="map-container"
      id="map"
    />
  );
};